export default __webpack_public_path__ + "static/media/html-logo.2c6a71b1.png";